import React from "react";
import Wordmark from "./Wordmark";
import { setPendingEdition } from "../services";

// The anonymous-recipient landing state for a shared Edition deep link
// (`?edition=...`). This is a legitimate pull, not a paywall: it names the
// exact experience being unlocked, then a single low-friction Google
// continue. No intake, no generic Test detour — successful auth returns
// straight into this Edition (see TasteTestApp's OAuth-callback handling).
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function EditionGateScreen({ edition, errored, onRetryHome }) {
  const continueWithGoogle = () => {
    setPendingEdition(edition.id);
    const redirectUrl = window.location.origin + "/";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };

  if (errored || !edition) {
    return (
      <div className="flex flex-col items-center justify-center h-[100dvh] gap-4 px-8 text-center max-w-[420px] mx-auto">
        <span className="font-display font-bold uppercase tracking-[0.2em] text-sm text-bone">
          This link isn't available
        </span>
        <p className="font-body text-[13px] text-silver leading-relaxed">
          The shared Edition link may have expired or been mistyped. You can still start your own Taste Test.
        </p>
        <button
          data-testid="edition-gate-retry"
          onClick={onRetryHome}
          className="font-body text-xs tracking-[0.18em] uppercase text-white/60 border border-white/15 rounded-full px-5 py-2.5 hover:text-white"
        >
          Start fresh
        </button>
      </div>
    );
  }

  return (
    <div
      data-testid="edition-gate"
      className="flex flex-col items-center justify-center h-[100dvh] gap-6 px-8 text-center max-w-[440px] mx-auto"
    >
      <Wordmark variant="horizontal" className="h-4" />
      <div className="h-px w-24" style={{ background: "linear-gradient(90deg,var(--tt-left),var(--tt-right))" }} />

      <div>
        <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-subtle">Taste Edition</p>
        <h1 className="mt-2 font-display font-black uppercase leading-[1.02] tracking-[-0.02em] text-bone text-4xl sm:text-5xl">
          {edition.title}
        </h1>
        <p className="mt-3 font-body text-sm text-silver">{edition.totalRounds} choices. Keep one each time.</p>
      </div>

      <p className="font-body text-[11px] tracking-[0.2em] uppercase text-white/55">
        Save your taste to play this Edition
      </p>

      <button
        type="button"
        data-testid="edition-gate-continue"
        onClick={continueWithGoogle}
        className="w-full flex items-center justify-center gap-3 rounded-full bg-bone text-[#0c0d12] py-3.5 font-display font-bold text-sm hover:opacity-90 transition-opacity"
      >
        <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden>
          <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.6l6.7-6.7C35.6 2.4 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.8 6.1C12.3 13.2 17.6 9.5 24 9.5z" />
          <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4.1 7.1-10.1 7.1-17.5z" />
          <path fill="#FBBC05" d="M10.4 28.7c-.5-1.4-.7-2.9-.7-4.7s.3-3.3.7-4.7l-7.8-6.1C.9 16.5 0 20.1 0 24s.9 7.5 2.6 10.8l7.8-6.1z" />
          <path fill="#34A853" d="M24 48c6.2 0 11.4-2 15.2-5.5l-7.5-5.8c-2 1.4-4.7 2.3-7.7 2.3-6.4 0-11.7-3.7-13.6-8.9l-7.8 6.1C6.5 42.6 14.6 48 24 48z" />
        </svg>
        Continue with Google
      </button>

      <button
        type="button"
        data-testid="edition-gate-home"
        onClick={onRetryHome}
        className="font-body text-[11px] tracking-[0.2em] uppercase text-white/45 hover:text-white/75"
      >
        Take the core Taste Test instead
      </button>
    </div>
  );
}
